import Base from 'app/views/base';
import LoaderView from 'app/views/loader_view';

import tmpl from 'templates/selector';

export const DEFAULT_BTN_CLASSES = 'btn-filter-dropdown';

export default Base.extend({
  compiledTemplate: tmpl,
  btnClasses: 'btn-filter-dropdown',

  events: {
    'click .dropdown-item': 'changeSelection',
  },

  initialize({ btnClasses = DEFAULT_BTN_CLASSES }) {
    this.btnClasses = btnClasses;
    this.listenTo(this.model, 'change', this.render);

    this.remoteCollection = this.model.remoteCollection;
    if (this.remoteCollection) {
      this.addSubview('loader', '#loader', new LoaderView({ collection: this.remoteCollection }));
    }
  },

  context() {
    return {
      label: this.model.label,
      choices: this.model.choices,
      currentChoice: this.model.get('currentChoice'),
      btnClasses: this.btnClasses,
      name: this.model.name,
    };
  },

  changeSelection(e) {
    e.preventDefault();
    this.model.set('currentChoice', {
      option: $(e.currentTarget).data('option'),
      readable: $(e.currentTarget).text(),
    });
  },
});



// WEBPACK FOOTER //
// ./app/views/selector_view.js